// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3m_ek","topBottomGutter":"Layout_topBottomGutter__2aJm9"};